var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lanmuc-liaxy"},[_c('div',{staticClass:"cpxxyd"},[_vm._m(0),_c('div',{staticClass:"lxnr"},[_c('ul',_vm._l((_vm.lianxiList),function(item){return _c('li',{key:item.id},[_c('p',[_vm._v(_vm._s(item.phone))]),_c('p',[_c('img',{attrs:{"src":item.erWei}})])])}),0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lix"},[_c('b',[_vm._v("联系方式")])])
}]

export { render, staticRenderFns }